/**
 * LICITARS 3.0 - Feature Flags Configuration
 * Controls which version of the interface to use
 */

/**
 * Check if LICITARS 3.0 interface should be used
 * Controlled by VITE_USE_V3 environment variable
 */
export const USE_V3_INTERFACE = import.meta.env.VITE_USE_V3 === "true";

/**
 * Environment configuration
 */
export const ENV = {
  USE_V3: USE_V3_INTERFACE,
  API_URL: import.meta.env.VITE_API_URL,
  APP_NAME: import.meta.env.VITE_APP_NAME || "LicitarsAI",
  APP_VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || "info",
  NODE_ENV: import.meta.env.NODE_ENV || "development",
};

// Log current configuration in development
if (ENV.NODE_ENV === "development") {
  console.log("🚀 LICITARS Configuration:", {
    version: USE_V3_INTERFACE ? "3.0 (Navy/Silver)" : "2.0 (Legacy)",
    useV3: USE_V3_INTERFACE,
    apiUrl: ENV.API_URL,
  });
}
